import React, { useState } from "react";
import css from "./DateRange.scss";
import { SingleDatePicker } from "react-dates";
import PropTypes from "prop-types";
import Moment from "moment";

const DateRange = props => {
  const [startDateFocused, setStartDateFocused] = useState(false);
  const [endDateFocused, setEndDateFocused] = useState(false);

  const startDateChange = (date) => {
    props.setSelectedTerm(null);
    props.setStartDate(date)
  };

  const endDateChange = (date) => {
    props.setSelectedTerm(null);
    props.setEndDate(date)
  };

  return (
    <div className={css['select-container']}>
      <div className={css['field-label']}>
        <span aria-hidden={true} className={css['star-required']}>* </span>
        <label htmlFor="start-date-select">Date Range: </label>
      </div>
      <div>
        <div className={css['daterange-select']}>
          <div className={css['date-select']}>
            <SingleDatePicker
              date={props.startDate}
              onDateChange={date => startDateChange(date)}
              focused={startDateFocused}
              onFocusChange={({ focused }) => setStartDateFocused(focused)}
              id="start-date-select"
              numberOfMonths={1}
              displayFormat="MM-DD-YYYY"
              placeholder="MM-DD-YYYY"
              showDefaultInputIcon
              inputIconPosition="after"
              small
              hideKeyboardShortcutsPanel
              openDirection="down"
              isOutsideRange={date => date.isAfter(props.endDate) || Math.abs(date.diff(props.endDate, 'days')) > 365}
              ariaLabel={"Start Date"}
            />
          </div>
          <label htmlFor={"end-date-select"} className={css['to-label']}>to</label>
          <div className={css['date-select']}>
            <SingleDatePicker
              date={props.endDate}
              onDateChange={date => endDateChange(date)}
              focused={endDateFocused}
              onFocusChange={({ focused }) => setEndDateFocused(focused)}
              id="end-date-select"
              numberOfMonths={1}
              displayFormat="MM-DD-YYYY"
              placeholder="MM-DD-YYYY"
              showDefaultInputIcon
              inputIconPosition="after"
              small
              keepOpenOnDateSelect={false}
              hideKeyboardShortcutsPanel
              openDirection="down"
              isOutsideRange={date => date.isBefore(props.startDate) || Math.abs(date.diff(props.startDate, 'days')) > 365}
              ariaLabel={"End Date. (select a maximum period of 365 days)"}
            />
          </div>
        </div>
        <span className={css["help-text"]}>
          Select a start and end date (with a maximum period of 365 days).
        </span>
      </div>
    </div>
  )
};

DateRange.propTypes = {
  startDate: PropTypes.instanceOf(Moment),
  setStartDate: PropTypes.func.isRequired,
  endDate: PropTypes.instanceOf(Moment),
  setEndDate: PropTypes.func.isRequired,
  setSelectedTerm: PropTypes.func.isRequired
};

export default DateRange;
